export default {
    SET_LATEST_VERSION_DATA: (state, version) => {
        state.latestVersionData = version
    },
    SET_SHOW_DIALOG: (state, boolean) => {
        state.showDialog = boolean
    }
}
